<script>
import FavoriteComponent from 'Vue/Web/Shop/Course/FavoriteComponent.vue';
import BarFavoriteComponent from 'Vue/Web/Shop/Course/BarFavoriteComponent.vue';
import MyMarkBlock from 'Vue/Web/Common/MyMarkBlock.vue';
import Banner from 'Vue/Web/Common/Banner.vue';
import RecommendNoteComponent from 'Vue/Web/Common/RecommendNoteComponent.vue';
import RecommendCourseComponent from 'Vue/Web/Common/RecommendCourseComponent.vue';
import RecommendProductComponent from 'Vue/Web/Common/RecommendProductComponent.vue';
import SectionDiscussComponent from 'Vue/Web/Common/SectionDiscussComponent.vue';
import SectionRatingComponent from 'Vue/Web/Common/Rating/SectionRatingComponent.vue';
import RightSideSalesComponent from 'Vue/Web/Shop/Course/RightSideSalesComponent.vue';

import EventBus from 'FF/Core/EventBus';
import 'lazysizes';

export default {
    components: {
        FavoriteComponent,
        BarFavoriteComponent,
        MyMarkBlock,
        EventBus,
        Banner,
        RecommendNoteComponent,
        RecommendCourseComponent,
        RecommendProductComponent,
        SectionRatingComponent,
        SectionDiscussComponent,
        RightSideSalesComponent,
    },
    el: '.wrap',
    data() {
        return {
            specificationDates: {},
            specificationPrograms: {},
            specifications: {},
            specification: {},
            Course: Json.Course,
            selectedSection: {
                Chapter: {
                    Sections: [],
                },
            },
            alreadyBuy: Boolean(Json.alreadyBuy),
            dateKey: 0,
            programKey: 0,
            inputAmount: 1,
            favoriteAddedData: false,
            discussComments: {},
            inWishOrder: false,
            wishOrderText: '馬上許願',
            totalWishOrderCount: 0,
            ajaxTrigger: false,
            wishOrderPercent: 0,
            authCheck: false,
            newHeader: false
        };
    },
    watch: {
        specification(value) {
            this.inputAmount = this.specification.baseNumber;
        },
        inputAmount(value) {
            if (value < this.specification.baseNumber) {
                this.inputAmount = this.specification.baseNumber;
            }
        },
        inWishOrder(value) {
            this.wishOrderText = value ? '已許願' : '馬上許願';
        },
    },
    methods: {
        barAddToCart(actionName) {
            if (actionName == 'addCart') {
                $('.cart-button')
                    .click();
            } else {
                $('.addcart-btn')
                    .click();
            }
        },
        changeProgramKey(payload) {
            this.programKey = payload.key;
            this.changeSpecification();
        },
        changeDateKey(payload) {
            this.dateKey = payload.key;
            this.changeSpecification();
        },
        changeSpecification() {
            if (this.specifications && this.specifications.length > 0) {
                this.specification =
                    this.specifications[this.dateKey][this.programKey];
            }
        },
        changeFavoriteAddedData(data) {
            this.favoriteAddedData = data;
        },
        playVideo(event, Section) {
            if (!Section.free && !this.alreadyBuy) {
                return false;
            }

            this.selectedSection.embedHtml = null;

            axios
                .get(`section/${Section.id}`)
                .then(({ data }) => {
                    this.selectedSection = data.selectedSection;

                    //   $(event.target).addClass("active");
                    $('.vedio-bg')
                        .show();
                    $('body')
                        .css('overflow-y', 'hidden');
                })
                .catch((err) => {
                    this.selectedSection = null;
                });
        },
        hideVideo() {
            $('.vedio-bg')
                .hide();
            $('body')
                .css('overflow-y', 'auto');
            this.selectedSection.embedHtml = null;
        },
        async wishOrderToggle() {

            if (this.ajaxTrigger || this.authCheck == false) {
                return false;
            }

            this.ajaxTrigger = true;
            await axios
                .post('course/toggleWishOrder', {
                    id: this.Course.id,
                })
                .catch((error) => {
                    global.Message.show(`失敗：${error}`);
                })
                .then((res) => {
                    this.inWishOrder = res.data.status == 1 ? true : false;
                    this.totalWishOrderCount = res.data.count ?? 0;
                    this.wishOrderPercent = res.data.wishOrderPercent ?? 0;
                    global.Message.show(this.inWishOrder ? '許願成功' : '取消許願');
                    this.ajaxTrigger = false;
                });
        }
    },
    created() {
        this.specifications = Json?.CourseSpecificationsByDate ?? [];
        this.specificationPrograms = [];
        this.specificationDates = [];
        this.inWishOrder = Json.inWishOrder;
        this.totalWishOrderCount = Json.totalWishOrderCount;
        this.wishOrderPercent = Json.wishOrderPercent;
        this.authCheck = Json.authCheck;

        this.specifications.forEach((specifications) => {
            let courseDate = specifications[0].courseDate;
            let specificationDatesId = specifications[0].specificationDatesId;
            let specificationPrograms = [];

            specifications.forEach((specification) => {
                specificationPrograms.push({
                    programName: specification.programName,
                    specificationPlanId: specification.specificationPlanId,
                    baseNumber: specification.baseNumber,
                    specification: specification,
                    prioritynum: specification?.specificationPlan?.prioritynum,
                });
            });

            specificationPrograms.sort((a, b) => b.prioritynum - a.prioritynum);

            this.specificationDates.push({
                courseDate,
                specificationDatesId,
                specificationPrograms,
            });
        });

        this.changeSpecification();

        const mainHeader = document.querySelector('.mainHeader');

        if (mainHeader) {
            this.newHeader = true;
        }
    },
    mounted() {
        EventBus.$on('changeFavoriteAddedData', this.changeFavoriteAddedData);






    },
};
</script>
